<script setup lang="ts">
import { IconStar, IconStarFilled } from "@tabler/icons-vue";

interface Props {
  rating: number;
}

defineProps<Props>();
</script>

<template>
  <div class="relative" :title="`${rating.round(4)}/5`">
    <div
      class="flex items-center gap-x-1"
      :style="{
        clipPath: `polygon(${Math.round((rating / 5) * 100)}% 0%, ${Math.round(
          (rating / 5) * 100,
        )}% 100%, 100% 100%, 100% 0%)`,
      }"
    >
      <IconStar v-for="star in 5" :size="20" />
    </div>
    <div
      class="absolute inset-0 flex items-center gap-x-1"
      :style="{
        clipPath: `polygon(0% 0%, 0% 100%, ${Math.round(
          (rating / 5) * 100,
        )}% 100%, ${Math.round((rating / 5) * 100)}% 0%)`,
      }"
    >
      <IconStarFilled
        v-for="star in 5"
        :size="20"
        class="text-nami-nami-blue"
      />
    </div>
  </div>
</template>

<style scoped lang="postcss"></style>
